module.exports = __webpack_public_path__ + "static/media/attachments_active.395e3b74.svg";